import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { bgGrey, textWhite } from '../../assets/styles/appStyles';

export default function WizardFooter({
  isSaving,
  saveLabel,
  saveClicked,
  cancelClicked,
}: {
  isSaving?: boolean;
  saveLabel?: string;
  saveClicked: () => void;
  cancelClicked: () => void;
}) {
  return (
    <Grid p={2} m={1} container justifyContent={'space-around'}>
      <Grid item md={3}>
        <Button variant="contained" sx={bgGrey} onClick={cancelClicked}>
          Cancel
        </Button>
      </Grid>
      <Grid item md={3}></Grid>
      <Grid item md={6}>
        <Grid container justifyContent={'flex-end'}>
          <Grid item ml={1}>
              <Box
                component={Button}
                variant="contained"
                sx={textWhite}
                onClick={saveClicked}
              >
                {saveLabel || 'Save'}
              </Box>
            {isSaving && <CircularProgress />}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
